// A SetupIntent can be confirmed exactly once. When the browser loses the
// answer to a confirm that Stripe actually accepted (api_connection_error on a
// flaky mobile connection), or the patient retries after /complete-checkout
// failed, the next confirm is rejected with setup_intent_unexpected_state and
// every later click fails the same way until the page is reloaded. The card
// was saved; only our view of it was lost. These helpers recover it.

export const SETUP_INTENT_UNEXPECTED_STATE = "setup_intent_unexpected_state";

// Errors after which the SetupIntent may already be succeeded at Stripe.
export function mayHaveSucceededAtStripe(error) {
  if (!error) return false;
  return (
    error.code === SETUP_INTENT_UNEXPECTED_STATE ||
    error.type === "api_connection_error"
  );
}

function paymentMethodIDOf(setupIntent) {
  const pm = setupIntent && setupIntent.payment_method;
  if (!pm) return "";
  return typeof pm === "string" ? pm : pm.id || "";
}

// Returns the saved payment method ID when the SetupIntent behind `error` has
// in fact succeeded, or "" when it has not (or Stripe can't be reached, in
// which case the caller shows the original error and the patient retries).
export async function recoverSucceededSetupIntent(stripe, clientSecret, error) {
  if (!mayHaveSucceededAtStripe(error)) return "";

  // Stripe attaches the intent to unexpected_state errors; use it when it
  // carries a status, otherwise ask Stripe.
  let setupIntent = error.setup_intent;
  if (!setupIntent || !setupIntent.status) {
    if (!clientSecret) return "";
    try {
      const result = await stripe.retrieveSetupIntent(clientSecret);
      setupIntent = result && result.setupIntent;
    } catch (e) {
      console.warn("retrieveSetupIntent failed: ", e);
      return "";
    }
  }

  if (!setupIntent || setupIntent.status !== "succeeded") return "";
  return paymentMethodIDOf(setupIntent);
}
